<h2 mat-dialog-title>Removing Entry No. {{ _timesheetFeature.selectedTimesheetLine()?.entryNo }}</h2>
<mat-dialog-content>
  @if (!_timesheetFeature.isLoadingDeletingTimesheetLine()) {
    <p>Are you sure you to delete entry no. {{ _timesheetFeature.selectedTimesheetLine()?.entryNo }} in timesheet no. {{ _timesheetFeature.selectedTimesheetLine()?.timesheetNo }}?</p>
  } @else {
    <div class="w-full flex flex-col flex-nowrap justify-center items-center gap-4">
      <p>Deleting entry please don't close the modal window.</p>
      <mat-spinner></mat-spinner>
    </div>
  }
</mat-dialog-content>
<mat-dialog-actions align="end">
  @if (!_timesheetFeature.isLoadingDeletingTimesheetLine()) {
    <button mat-button (click)="deleteEntry()">Yes</button>
    <button mat-button mat-dialog-close>No</button>
  } @else {}
</mat-dialog-actions>
